import { defaultFromDate } from "@helpers/dates";
import moment from "moment";

const defaultReducer = (key, initialState) => {
  return (state = initialState, action) => {
    switch (action.type) {
      case key:
        return typeof action.payload === "string"
          ? action.payload
          : { ...state, ...action.payload };
      default:
        return state;
    }
  };
};

const initialState = {
  loading: false,
  grid: { data: [], headerDef: [], rowDef: [], pageCount: 1, pageNumber: 1 },
  summary: { data: [], headerDef: [], rowDef: [] },
  showSummary: false,
};

const viewInitialState = {
  activeIndex: 0,
  exportLoading: false,
  searchParams: {
    startDate: moment(defaultFromDate).toISOString(true),
    endDate: moment().toISOString(true),
    companyId: null,
    subCompanyId: null,
    siteId: null,
    includeEvents: false,
    sessionId: "",
    week: null,
    transactionRef: "",
    assetNo: "",
    playerId: null,
    username: "",
    useCurrentWeek: true,
    selectedFilterType: "1",
    selectedFilterValue: "-1",
    ticketSerial: null,
  },
  ticketsView: 1,
  filterTypes: [],
  filterValues: [],
  periods: [],
  useCurrentDateTime: true,
  useCollectionWeek: 1,
  showSummary: true,
};

export const transactionsReducer = defaultReducer(
  "FETCH_TRANSACTIONS",
  initialState,
);
export const transactionsTicketsReducer = defaultReducer(
  "TRANSACTIONS_TICKETS",
  initialState,
);
export const transactionsLiabilityReducer = defaultReducer(
  "TRANSACTIONS_LIABILITY",
  initialState,
);
export const transactionsKioskReducer = defaultReducer(
  "TRANSACTIONS_KIOSK",
  initialState,
);
export const transactionsViewReducer = defaultReducer(
  "TRANSACTIONS_VIEW",
  viewInitialState,
);

export const transactionAdjustReducer = defaultReducer(
  "SET_TRANSACTION_ADJUST",
  "",
);
export const transactionAuthoriseReducer = defaultReducer(
  "SET_TRANSACTION_AUTHORISE",
  "",
);
export const transactionVoidReducer = defaultReducer(
  "SET_TRANSACTION_VOID",
  "",
);
